<ion-menu swipeGesture="false" side="start" menuId="sidemenu" contentId="puzzle-screen-container" (ionWillOpen)="menuWillOpen()" (ionDidClose)="menuDidClose()">
  <app-puzzle-sidenav></app-puzzle-sidenav>
</ion-menu>
<ion-content id="puzzle-screen-container" class="puzzle-screen-container" [class.removeSideMargins]="removeSideMargins">
  <app-puzzle-screen></app-puzzle-screen>
</ion-content>
